function SuspenseContent(){
    return(
        // data-page-loading: the page's code is still on its way (the refusing-server guard waits for it).
        <div className="w-full h-screen text-gray-300 dark:text-gray-200 bg-base-100" data-page-loading>
            Loading...
        </div>
    )
}

export default SuspenseContent